import { CapturumUIPreset } from '@capturum/ui/config';
import { definePreset, palette } from '@primeng/themes';

// Seeded on brand Vivid Green. PrimeNG renders primary controls as {capturum.500} bg
// with white ({surface.0}) text to match the component design. NOTE: white on #10b981 is
// ~2.5:1 — below WCAG AA — an accepted brand decision (product owner), not an oversight.
const neqtoPalette = palette('#10b981');

export const neqtoPreset = definePreset(CapturumUIPreset, {
  primitive: {
    capturum: neqtoPalette,
  },
  components: {
    dialog: {
      border: {
        radius: 0,
      },
    },
    tabs: {
      tab: {
        fontWeight: '400',
      },
      activeBar: {
        background: 'var(--cap-primary-color)',
        height: '3px',
      },
    },
    autocomplete: {
      focusRing: {
        shadow: 'none',
      },
    },
    select: {
      disabledBackground: 'var(--input-disabled-background)',
    },
  },
});
